<template>
    <div class="d-inline-block">
        <b-button v-if="size === 'md'" variant="custom-green" class="fs-14 button-icon" :class="`mt-${mt}`" @click="showSignModal = true" title="Информация о подписи">
            <b-icon-clipboard-check />
        </b-button>
        <action-button-small v-else-if="size === 'sm'" icon="clipboard-check" title="Информация о подписи" @click="showSignModal = true" />
        <b-modal :visible="showSignModal" centered no-close-on-backdrop no-close-on-esc hide-footer size="md" :title="title" @close="showSignModal = false" header-class="pb-1" body-class="pt-1">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <template v-if="customerSignature">
                <text-row label="Заказчик" :value="customerSignature.organization_name" class="pl-0" compact />
                <text-row label="ФИО" :value="customerSignature.user_name" compact />
                <text-row-link v-if="customerSignature.poa_check_link" label="МЧД" :href="customerSignature.poa_check_link" :value="customerSignature.poa_number" compact />
                <text-row-datetime label="Дата и время" :value="customerSignature.sign_datetime" />
                <div class="signature">
                    <pre class="sign-text">
                        {{ customerSignature.md5 }}
                    </pre>
                </div>
                <b-button v-if="allowDownloadXml && customerSignature.xml" variant="custom-outline-secondary" class="fs-14 mt-2" :class="`mt-${mt}`" @click="downloadXml('customer_', customerSignature.xml)">Скачать xml файл</b-button>
            </template>
            <template v-if="supplierSignature">
                <text-row label="Поставщик" :value="supplierSignature.organization_name" class="pl-0" compact />
                <text-row label="ФИО" :value="supplierSignature.user_name" compact />
                <text-row-link v-if="supplierSignature.poa_check_link" label="МЧД" :href="supplierSignature.poa_check_link" :value="supplierSignature.poa_number" compact />
                <text-row-datetime label="Дата и время" :value="supplierSignature.sign_datetime" />
                <div class="signature">
                    <pre class="sign-text">
                        {{ supplierSignature.md5 }}
                    </pre>
                </div>
                <b-button v-if="allowDownloadXml && supplierSignature.xml" variant="custom-outline-secondary" class="fs-14 mt-2" :class="`mt-${mt}`" @click="downloadXml('supplier_', supplierSignature.xml)">Скачать xml файл</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { encodeBase64, saveAs } from '@progress/kendo-file-saver';

export default {
    name: 'signature-xml-info-button',
    props: {
        title: {
            type: String,
            default: 'Электронная подпись'
        },
        customerSignature: {
            type: Object,
            default: null
        },
        supplierSignature: {
            type: Object,
            default: null
        },
        filename: {
            type: String,
            default: 'signature_info'
        },
        mt: {
            type: Number,
            default: 2
        },
        allowDownloadXml: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md'
        }
    },
    data() {
        return {
            showSignModal: false
        };
    },
    methods: {
        downloadXml(prefix, xml) {
            const downloadData = 'data:text/plain;base64,' + encodeBase64(xml);
            const downloadFileName = prefix + this.filename + '.xml';
            saveAs(downloadData, downloadFileName);
        }
    }
};
</script>
<style scoped>
.button-icon {
    width: 35px !important;
    min-width: 35px !important;
    padding-left: 8px !important;
}
.signature {
    height: 100px;
    overflow: auto;
    font-size: 0.75em;
    line-break: anywhere;
}
.sign-text {
    white-space: pre-line;
}
pre {
    font-size: 100%;
}
</style>
